module.exports = __webpack_public_path__ + "img/background.1beb19e8.png";